import CameraIcon from "@heroicons/react/24/outline/CameraIcon";
import { FunctionComponent } from "react";

interface TakePhotoButtonProps {
  canvasRef: React.RefObject<HTMLCanvasElement>;
}

const TakePhotoButton: FunctionComponent<TakePhotoButtonProps> = ({ canvasRef }) => {
  return (
    <div
      onClick={() => {
        var link = document.createElement("a");
        link.download = "model.png";
        link.href = canvasRef.current?.toDataURL() ?? "";
        link.click();
      }}
      className="absolute right-0 top-0 flex px-3 py-2 bg-gray-200 hover:bg-gray-300 cursor-pointer select-none active:bg-main-to active:text-white"
    >
      <CameraIcon className="w-5" />
    </div>
  );
};

export default TakePhotoButton;
